var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    id: "coin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2861_3821)",
    fillRule: "evenodd",
    d: "M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#850026",
    fillRule: "evenodd",
    d: "M12.9995 1.04483C12.6702 1.01516 12.3367 1 11.9997 1C11.6625 1 11.3289 1.01517 10.9995 1.04486V4.06191C11.3272 4.02105 11.661 4 11.9997 4C12.3383 4 12.672 4.02104 12.9995 4.06187V1.04483ZM3.01159 5.65723C2.82295 5.92406 2.6459 6.19966 2.48115 6.4833L2.45158 6.53454C2.29251 6.81183 2.14518 7.09671 2.01025 7.3885L4.62386 8.89714C4.88539 8.2762 5.22303 7.6952 5.62511 7.16581L3.01159 5.65723ZM2.01025 16.6117C2.14518 16.9035 2.29251 17.1883 2.45158 17.4656L2.48116 17.5169C2.6459 17.8005 2.82295 18.0761 3.01159 18.3429L5.62511 16.8344C5.22303 16.305 4.88539 15.724 4.62386 15.103L2.01025 16.6117ZM12.9995 22.9551C12.6702 22.9847 12.3367 22.9999 11.9997 22.9999C11.6625 22.9999 11.3289 22.9847 10.9995 22.955V19.938C11.3272 19.9789 11.661 19.9999 11.9997 19.9999C12.3383 19.9999 12.672 19.9789 12.9995 19.938V22.9551ZM20.988 18.3429C21.1667 18.0902 21.335 17.8296 21.4923 17.5617L21.574 17.4202C21.7231 17.1573 21.8618 16.8876 21.9894 16.6117L19.3758 15.103C19.1143 15.724 18.7766 16.305 18.3745 16.8343L20.988 18.3429ZM21.574 6.57992C21.7231 6.84288 21.8618 7.1126 21.9894 7.38849L19.3758 8.89712C19.1143 8.27619 18.7766 7.69519 18.3745 7.16581L20.988 5.65723C21.1667 5.90997 21.335 6.17057 21.4923 6.43843L21.574 6.57992Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2861_3821",
    x1: 0,
    x2: 24,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#FF6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F72257"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.cf057673295f608b71be2f2189b462a7.svg";
export { ForwardRef as ReactComponent };